import { render, staticRenderFns } from "./TuitionSubjectSetSchedule.vue?vue&type=template&id=bbaa30a0&scoped=true&"
import script from "./TuitionSubjectSetSchedule.vue?vue&type=script&lang=js&"
export * from "./TuitionSubjectSetSchedule.vue?vue&type=script&lang=js&"
import style0 from "./TuitionSubjectSetSchedule.vue?vue&type=style&index=0&id=bbaa30a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbaa30a0",
  null
  
)

export default component.exports